import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "button"]

  toggle() {
    const isOpen = !this.contentTarget.classList.contains("hidden")
    
    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.contentTarget.classList.remove("hidden")
    this.iconTarget.classList.add("rotate-180")
    this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.contentTarget.classList.add("hidden")
    this.iconTarget.classList.remove("rotate-180")
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }
}